import ImageClass from "../../src/shell/Image";
import { jump } from "../../src/shell/jump";
import { mc } from "../characters/MC";
import { images } from "./images";
import { V8EmilyAloneAfter } from "./V8";
import Question from '../../src/shell/Questions';
import { emily } from '../characters/Emily';
import { doWaitImageByTime } from "../helpers/helpers";
import Game from "../../src/shell/Game";
import { endReplay } from "../../src/shell/endReplay";
import { replayScenesList } from "../../src/components/menu/Scenes/replayScenes/scenesReplayData";

export const V8EmilyAlone = async (): Promise<any> => {
    if (Game.seenScenarios.includes(`V8AnnWebcam`)) {

        doWaitImageByTime({ ...images.v8.V8MCRoomAnnWebcam_0, partialsToDisplay: [images.v8.V8MCRoomAnnWebcam_0.partials.V8MCRoomAnnWebcam_0_p_1] });
        mc.think(`I think I heard Emily while talking with Ann...`);
        if (mc.properties.gotKissedByEmily) {

            mc.think(`I can't just avoid her...`);
            mc.think(`I should act normally and see if she will brings up the kiss...`);
            mc.think(`And "normally" means I should go and say hey like I usually do...`);

        } else {
            mc.think(`I haven't seen her all day I should go and say hey!`);
        }
    } else {
        mc.talk(`I think Emily's home...`);
    }

    doWaitImageByTime(images.v8.V8EmilyAndExRoom_18);
    if (mc.properties.gotKissedByEmily) {

        mc.think(`Ok... Deep breaths...`);
        mc.think(`Just act normal... Don't think too much of it and you'll be fine.`);
    } else {
        mc.think(`Weird... She usually keeps her door open.`);

    }
    doWaitImageByTime(images.v8.V8EmilyMasturbationFar);
    await mc.setQuestion(new Question({ text: `Oh shit!`, options: { think: true }, key: `V8EmilyMasturbatingAloneKeepWatching` })
        .option({ title: `Keep watching`, key: true })
        .option({ title: `Go to your room`, key: false }));


    if (Question.globalAnswers.V8EmilyMasturbatingAloneKeepWatching) {
        mc.think(`Oh well... I already saw it, there is no point in leaving now.`);
        ImageClass.setImage(images.v8.Anim_EmilyMasturbation.poster, { duration: 1, wait: 1, hideText: true });
        ImageClass.setAnimations([
            { ...images.v8.Anim_EmilyMasturbation, options: { loop: 1 } },
            { ...images.v8.Anim_EmilyMasturbationFingers, options: { loop: 999999 } }
        ]);
        mc.think(`I always knew she masturbated, but I never caught her during it...`);
        ImageClass.setAnimation(images.v8.Anim_EmilyMasturbationFingers, { speed: 2 });
        emily.talk(`Ah...`);
        await endReplay(replayScenesList.v8EmilyAlone);
    } else {

        ImageClass.setImage(images.v8.V8EmilyAndExRoom_18);
        mc.think(`That's an image that is going to stay with me...`);
        await endReplay();
    }


    return jump(V8EmilyAloneAfter, "V8EmilyAloneAfter");
};